import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { APP_NAME } from "../config/branding";

/** Shared sticky header for public marketing pages. */
export const PublicHeader = () => (
  <header className="border-b border-border/40 sticky top-0 z-40 bg-background/95 backdrop-blur-sm" data-testid="public-header">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between h-14">
        <Link to="/" className="font-heading font-semibold text-lg tracking-tight" data-testid="public-header-logo">
          {APP_NAME}
        </Link>
        <div className="flex items-center gap-3">
          <Link to="/blog" className="hidden sm:block">
            <Button variant="ghost" size="sm">Blog</Button>
          </Link>
          <Link to="/pricing">
            <Button variant="ghost" size="sm">Pricing</Button>
          </Link>
          <Link to="/login">
            <Button variant="ghost" size="sm" data-testid="public-header-login-btn">Log in</Button>
          </Link>
          <Link to="/register">
            <Button size="sm" data-testid="public-header-get-started-btn">Get Started</Button>
          </Link>
        </div>
      </div>
    </div>
  </header>
);

export default PublicHeader;
